export default __webpack_public_path__ + "static/media/logo-light.627c5d38.svg";